import styled from 'styled-components';
import { createMuiTheme } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';
import homeImage from '../../assets/middle_background_sabor.jpg';

export const Container = styled.div`
  height: 91vh;
  display: flex;
  align-items: stretch;
  background: #fdfee8;
`;

export const CardContainer = styled.div`
  justify-content: space-between;
  background: #fff;
  flex-direction: column;
  display: flex;
  margin: 0 20px;
  border: 4px solid orange;
  border-radius: 8px;
  align-items: center;
  padding-top: 5px;

  margin-top: 5px;
  -webkit-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
`;

export const MainContent = styled.div`
  /* margin-top: ${props => (props.userData === 1 ? `15px` : `95px`)}; */
  margin-top: 15px;
`;
export const InputContainer = styled.div`
  flex-direction: column;
  display: flex;
  margin-top: 3px;
`;
export const MenuItem = styled.div`
  display: flex;
`;
export const ButtonContainer = styled.div`
  display: flex;
  margin: 20px 0;
  align-items: center;
  justify-content: space-between;
  button {
    width: 160px;
  }
`;
export const CheckBoxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Background = styled.div`
  flex: 1;
  background: url(${homeImage}) no-repeat center;
  background-size: cover;
`;

export const ImgContainer = styled.div`
  display: flex;
  width: 450px;
`;

export const theme = createMuiTheme({
  palette: {
    primary: orange,
    secondary: {
      main: '#2c2e2c',
    },
  },
  overrides: {
    MuiInputLabel: {
      root: {
        fontSize: '12px',
        fontFamily: 'Roboto',
      },
    },
    MuiInputBase: {
      root: {
        height: '40px',
      },
    },
  },
});
